import React from "react";
import { Outlet } from "react-router-dom";

const GovernmentServices = (_props) => {
  return <Outlet />;
};

export default GovernmentServices;
